import { Action, createReducer, on } from '@ngrx/store';
import * as GeneralSettingsActions from './general-settings.actions';
import { IGeneralSettingsState, initialGeneralSettingsState } from './general-settings.state';

const generalSettingsReducerInternal = createReducer(
  initialGeneralSettingsState,
  on(GeneralSettingsActions.setGeneralSettingsData, (state, { data }) => ({
    ...state,
    ...data,
  })),
  on(GeneralSettingsActions.clearGeneralSettingsData, (state) => ({
    ...state,
    ...initialGeneralSettingsState,
  }))
);

export function generalSettingsReducer(
  state: IGeneralSettingsState | undefined,
  action: Action
): IGeneralSettingsState {
  return generalSettingsReducerInternal(state, action);
}
